import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import LogoContainer from "../common/LogoContainer";
import TransactionActivity from "./TransactionActivity";
import TransactionGraph from "./TransactionGraph";
import TransactionTab from "./TransactionTab";

export default function TransactionsFinancialAccount() {
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className="row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="transactions-page">
                        Transactions
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>
            <TransactionTab selectedTab="1" />
            <div className="row" id="content">
                <TransactionActivity />
                <TransactionGraph />
            </div>
        </React.Fragment>
    );
}
